import React, {useState, useEffect} from "react";

export default function OverallPrimoFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M-132.145,254.105c-0.726-11.143-1.732-24.314-3.664-37.547c-0.76-5.2-1.268-10.49-1.754-15.606
		c-0.257-2.703-0.525-5.491-0.827-8.239c-0.235-2.145-0.67-4.307-1.094-6.396c-0.246-1.234-0.503-2.508-0.715-3.765
		c-0.927-5.474-1.916-11.037-2.927-16.539c-2.541-13.802-6.184-26.817-10.032-40.591c-0.492-1.743-0.978-3.491-1.469-5.245
		c-4.112-14.79-8.702-28.246-13.278-38.915c-1.575-3.68-3.15-7.188-4.412-10.014c-1.469-3.284-2.743-6.122-2.754-6.446h-0.128
		l0.055-0.056c-0.492-0.508-0.536-0.542-0.721-0.637c-0.083-0.044-0.212-0.106-0.497-0.302
		c-11.842-8.065-36.402-16.03-41.892-17.756c0.284-0.531-0.112-1.609-0.631-2.86c-0.107-0.245-0.195-0.463-0.257-0.625
		l-4.284-11.657c-0.765-1.849-2.374-3.189-4.296-3.592c-2.468-0.519-5.485-0.631-8.144-0.731c-0.771-0.034-1.519-0.062-2.229-0.095
		c-3.222-0.168-6.646-0.224-10.45-0.19c-4.435,0.045-10.512,0.106-15.282,0.804c-0.459,0.068-0.91,0.14-1.363,0.212l-0.53,0.084
		c-1.061,0.168-2.011,0.726-2.682,1.581l-6.127,13.975l-0.135,0.313c-0.296,0.698-0.531,1.257-0.536,1.519
		c-0.005,0.29,0.107,0.559,0.302,0.76c-27.135,8.183-39.518,14.444-45.121,18.259c-0.285,0.196-0.419,0.258-0.502,0.302
		c-0.184,0.096-0.224,0.129-0.721,0.637l0.061,0.056h-0.133c0,0.693-0.66,1.715-1.19,2.536c-0.207,0.318-0.408,0.62-0.537,0.871
		c-1.357,2.541-2.681,5.027-3.932,7.557c-2.816,5.675-4.927,11.601-7.021,17.684c-4.284,12.433-7.937,25.235-10.858,38.06
		c-0.995,4.379-2.117,8.825-3.201,13.121c-1.128,4.469-2.296,9.093-3.329,13.662c-2.882,12.763-5.183,26.185-7.044,41.038
		c-0.245,1.955-0.474,3.916-0.703,5.876c-0.436,3.726-0.888,7.574-1.441,11.35c-1.234,8.429-2.09,16.823-2.732,24.688l-0.034,0.107
		c0.006,0,0.017,0,0.022,0.006c-0.363,4.413-0.659,8.663-0.915,12.645c-0.078,0.068-0.134,0.157-0.14,0.274
		c-0.012,0.179,0.083,0.336,0.24,0.392c11.194,3.865,18.84,4.904,23.829,4.904c2.563,0,4.429-0.274,5.708-0.581
		c0.022-0.012,0.459-0.223,0.643-0.788c0.045-0.268,4.513-26.889,6.122-31.386c1.357-3.798,10.456-37.395,11.629-43.847
		c0.749-4.122,3.173-12.802,5.519-21.202c0.352-1.262,0.704-2.519,1.044-3.759c2.056,24.99,3.894,50.081,3.592,56.599
		c-0.006,0.095-0.503,9.429-0.945,13.316c-0.05,0.436-0.078,0.877-0.106,1.301c-0.045,0.743-0.095,1.508-0.257,2.24
		c-1.71,7.68-3.86,22.946-4.436,52.046c-0.173,8.954-0.419,19.679-0.681,31.029c-0.933,40.809-1.988,87.063-0.905,92.487
		c0.541,2.687,0.631,17.88,0.737,35.469c0.168,28.057,0.38,62.978,2.446,68.58l0.033,0.084l0.079,0.022
		c0.134,0.039,9.077,2.726,22.951,2.726c6.982,0,15.209-0.681,24.197-2.72c0.184,0,0.184,0,0.374-3.419
		c0.111-2.072,0.268-5.038,0.457-8.59c0.369-7.111,0.855-16.59,1.341-26.068c0.966-18.958,1.921-37.921,1.921-37.921
		c0.027-0.559,2.379-56.454,1.787-79.606c0.788-17.645,4.916-34.731,4.966-34.938c0.138-3.62,0.552-10.149,1.306-15.765h0.043
		v-0.314c0.74-5.379,1.796-9.842,3.23-9.956v0.006c2.882,0.151,4.246,17.89,4.575,25.481c-0.006,0.062-0.006,0.101-0.006,0.112
		h0.011c0.006,0.156,0.012,0.324,0.017,0.475c0.045,0.168,4.172,17.26,4.96,34.888c-0.592,23.164,1.765,79.059,1.787,79.623
		c0,0,0.955,18.957,1.921,37.915c0.486,9.478,0.972,18.958,1.341,26.068c0.19,3.552,0.346,6.518,0.464,8.59
		c0.184,3.43,0.201,3.43,0.335,3.424c9.004,2.044,17.249,2.72,24.237,2.72c13.885,0,22.822-2.681,22.957-2.72l0.084-0.028
		l0.034-0.084c2.072-5.607,2.279-40.529,2.446-68.585c0.107-17.589,0.202-32.776,0.738-35.469
		c1.083-5.424,0.028-51.673-0.905-92.481c-0.184-7.999-0.357-15.696-0.509-22.678c-0.061-2.921-0.122-5.714-0.173-8.357
		c-0.564-28.62-3.094-48.388-5.273-57.348c-0.279-1.139-0.452-2.055-0.552-2.893c-0.084-0.726-0.096-1.486-0.101-2.224
		c-0.006-0.34-0.012-0.675-0.017-1.005l-0.028-0.788c-0.083-2.492-0.167-5.072-0.145-7.608c0.017-1.229,0.045-2.53,0.106-4.212
		c0.056-1.62,0.128-3.357,0.218-5.318c0.1-2.089,0.207-4.178,0.324-6.267c0.128-2.346,0.268-4.693,0.413-7.038
		c0.151-2.553,0.313-5.105,0.48-7.652c0.179-2.703,0.357-5.407,0.542-8.105c0.19-2.798,0.386-5.591,0.587-8.389
		c0.117-1.698,0.24-3.402,0.362-5.105l0.52,1.854c2.446,8.815,4.764,17.143,5.569,21.555c1.167,6.452,10.266,40.049,11.629,43.847
		c1.609,4.497,6.072,31.118,6.128,31.414c0.179,0.537,0.614,0.748,0.67,0.771c1.263,0.301,3.111,0.57,5.659,0.57
		c4.977,0,12.629-1.033,23.839-4.904l0.128-0.045L-132.145,254.105z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M-332.084,246.501c-1.613,0.297-3.512,0.448-5.653,0.448c-6.882,0-15.518-1.519-25.684-4.515"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M-163.782,246.358c1.618,0.261,3.003,0.359,5.144,0.31c6.88-0.155,14.913-1.689,25.008-4.914"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M-274.024,44.145c5.326-0.871,30.382-4.465,54.729,0.437"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6909,0.5183"
          d="
		M-311.091,503.787c0,0,21.463,6.33,48.612,0.176"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6909,0.5183"
          d="
		M-183.887,503.787c0,0-21.581,6.33-48.73,0.176"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.5183,0.5183"
          d="
		M-243.157,311.27c0.28-6.105,0.67-15.486,0.509-16.992c-0.243-2.263-3.309-3.708-4.738-3.282h-0.062
		c-1.429-0.427-4.495,1.019-4.738,3.282c-0.16,1.486,0.219,10.639,0.497,16.747"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.5183,0.5183"
          d="
		M-250.856,304.882v-8.464c0-1.089,0.406-2.149,1.174-2.92c0.528-0.53,1.191-0.817,2.15-0.827"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.5183,0.5183"
          d="
		M-244.005,304.957l-0.118-8.582c0-1.088-0.406-2.149-1.173-2.92c-0.528-0.53-1.191-0.817-2.15-0.827"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M-305.931,204.859c0,0,51.715,4.311,116.551,0"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M-305.931,213.518c0,0,51.715,4.311,116.551,0"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		-297.11,227.452 -298.062,267.418 -293.553,272.153 -262.659,272.911 -257.923,268.402 -256.97,228.388 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		-298.94,227.383 -299.892,267.373 -299.911,268.131 -299.388,268.68 -294.879,273.416 -294.355,273.965 -293.597,273.984 
		-262.704,274.741 -261.946,274.76 -261.397,274.237 -256.661,269.727 -256.111,269.204 -256.092,268.446 -255.139,228.433 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          x1="-296.57"
          y1="232.439"
          x2="-257.689"
          y2="233.392"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		-197.307,227.452 -196.355,267.418 -200.865,272.153 -231.759,272.911 -236.495,268.402 -237.448,228.388 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		-195.478,227.383 -194.525,267.373 -194.507,268.131 -195.03,268.68 -199.539,273.416 -200.063,273.965 -200.82,273.984 
		-231.714,274.741 -232.472,274.76 -233.021,274.237 -237.757,269.727 -238.307,269.204 -238.325,268.446 -239.278,228.433 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          x1="-197.848"
          y1="232.439"
          x2="-236.729"
          y2="233.392"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M-302.028,55.507c0,0,13.996,46.017,22.164,154.391"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          d="
		M-193.679,55.507c0,0-13.996,46.017-22.164,154.391"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          x1="-297.39"
          y1="257.574"
          x2="-258.353"
          y2="258.266"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          x1="-197.246"
          y1="257.574"
          x2="-236.284"
          y2="258.266"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="-282.507"
          y1="232.252"
          x2="-282.492"
          y2="231.878"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="-282.465"
          y1="231.23"
          x2="-282.465"
          y2="231.225"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6535,0.6485"
          x1="-282.465"
          y1="231.225"
          x2="-282.358"
          y2="228.613"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          points="-282.357,228.614 -282.342,228.239 
		-281.967,228.248 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="-281.245"
          y1="228.265"
          x2="-281.239"
          y2="228.265"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7289,0.7228"
          x1="-281.239"
          y1="228.265"
          x2="-272.498"
          y2="228.478"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          points="-272.498,228.478 -272.122,228.487 
		-272.132,228.862 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="-272.149"
          y1="229.52"
          x2="-272.149"
          y2="229.525"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6636,0.658"
          x1="-272.149"
          y1="229.525"
          x2="-272.217"
          y2="232.177"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="-272.217"
          y1="232.177"
          x2="-272.226"
          y2="232.553"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="-212.067"
          y1="232.252"
          x2="-212.082"
          y2="231.878"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="-212.109"
          y1="231.23"
          x2="-212.11"
          y2="231.225"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6535,0.6485"
          x1="-212.109"
          y1="231.225"
          x2="-212.217"
          y2="228.613"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          points="-212.217,228.614 -212.232,228.239 
		-212.607,228.248 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="-213.33"
          y1="228.265"
          x2="-213.336"
          y2="228.265"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7289,0.7228"
          x1="-213.336"
          y1="228.265"
          x2="-222.077"
          y2="228.478"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          points="-222.077,228.478 -222.452,228.487 
		-222.442,228.862 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="-222.426"
          y1="229.52"
          x2="-222.425"
          y2="229.525"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.6636,0.658"
          x1="-222.425"
          y1="229.525"
          x2="-222.358"
          y2="232.177"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          x1="-222.358"
          y1="232.177"
          x2="-222.348"
          y2="232.553"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		-196.717,288.597 -196.136,334.361 -194.058,336.021 -182.74,336.021 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          points="
		-195.6,288.583 -195.025,333.818 -193.667,334.904 -182.74,334.904 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2514"
          strokeMiterlimit="10"
          strokeDasharray="0.7501,0.7496"
          x1="-195.318"
          y1="291.15"
          x2="-184.085"
          y2="291.15"
        />
        <path
          fill="#010101"
          d="M-299.72,226.165l-0.184-0.006l-0.743,31.571l-0.262,10.708v0.078l6.116,6.429l33.162,0.81h0.073
		l6.429-6.122l1.011-42.395L-299.72,226.165z M-255.231,258.841l-0.257,10.636l-6.211,5.915l-32.933-0.81l-5.915-6.211l1-41.837
		l45.059,1.056L-255.231,258.841z"
        />
        <path
          fill="#010101"
          d="M-194.515,226.16l-45.6,1.072l-0.184,0.006l0.748,31.61l0.262,10.713v0.073l6.379,6.072l0.051,0.05
		l33.156-0.81h0.079l6.121-6.428L-194.515,226.16z M-199.788,274.582l-32.927,0.81l-6.211-5.915l-1-41.887l45.054-1.056
		l0.737,31.202l0.263,10.635L-199.788,274.582z"
        />
        <path
          fill="#010101"
          d="M-132.145,254.105c-0.726-11.143-1.732-24.314-3.664-37.547c-0.76-5.2-1.268-10.49-1.754-15.606
		c-0.257-2.703-0.525-5.491-0.827-8.239c-0.235-2.145-0.67-4.307-1.094-6.396c-0.246-1.234-0.503-2.508-0.715-3.765
		c-0.927-5.474-1.916-11.037-2.927-16.538c-2.541-13.802-6.184-26.817-10.032-40.591c-0.492-1.743-0.977-3.491-1.469-5.245
		c-4.112-14.79-8.702-28.246-13.278-38.915c-1.575-3.68-3.15-7.188-4.412-10.014c-1.469-3.284-2.743-6.122-2.754-6.446h-0.128
		l0.055-0.056c-0.492-0.508-0.536-0.542-0.721-0.637c-0.083-0.044-0.212-0.106-0.497-0.302
		c-11.842-8.065-36.402-16.03-41.892-17.756c0.284-0.531-0.112-1.609-0.631-2.86c-0.107-0.245-0.195-0.463-0.257-0.625
		l-4.284-11.657c-0.765-1.849-2.374-3.189-4.296-3.592c-2.468-0.519-5.485-0.631-8.144-0.731c-0.771-0.034-1.519-0.062-2.229-0.095
		c-3.222-0.168-6.646-0.224-10.45-0.19c-4.435,0.045-10.512,0.106-15.282,0.804c-0.459,0.068-0.91,0.14-1.363,0.212l-0.53,0.084
		c-1.061,0.168-2.011,0.726-2.682,1.581l-6.127,13.975l-0.135,0.313c-0.296,0.698-0.531,1.257-0.536,1.519
		c-0.005,0.29,0.107,0.559,0.302,0.76c-27.135,8.183-39.518,14.444-45.121,18.259c-0.285,0.196-0.419,0.257-0.502,0.302
		c-0.184,0.095-0.224,0.129-0.721,0.637l0.061,0.056h-0.133c0,0.693-0.66,1.715-1.19,2.536c-0.207,0.318-0.408,0.62-0.537,0.871
		c-1.357,2.541-2.681,5.027-3.932,7.557c-2.816,5.675-4.927,11.601-7.021,17.684c-4.284,12.433-7.937,25.235-10.858,38.06
		c-0.995,4.379-2.118,8.825-3.201,13.121c-1.128,4.469-2.296,9.093-3.329,13.662c-2.882,12.763-5.183,26.185-7.044,41.038
		c-0.245,1.955-0.474,3.916-0.703,5.876c-0.436,3.726-0.888,7.574-1.441,11.35c-1.234,8.429-2.09,16.823-2.732,24.688l-0.034,0.107
		c0.006,0,0.017,0,0.022,0.006c-0.363,4.413-0.659,8.663-0.915,12.645c-0.078,0.068-0.134,0.157-0.14,0.274
		c-0.012,0.179,0.083,0.336,0.24,0.392c11.194,3.865,18.84,4.904,23.829,4.904c2.563,0,4.429-0.274,5.708-0.581
		c0.022-0.012,0.459-0.223,0.643-0.788c0.045-0.268,4.513-26.889,6.122-31.386c1.357-3.798,10.456-37.395,11.629-43.847
		c0.749-4.122,3.173-12.802,5.519-21.202c0.352-1.262,0.704-2.519,1.044-3.759c2.056,24.99,3.894,50.081,3.592,56.599
		c-0.006,0.095-0.503,9.429-0.945,13.316c-0.05,0.436-0.078,0.877-0.106,1.301c-0.045,0.743-0.095,1.508-0.257,2.24
		c-1.71,7.68-3.86,22.946-4.436,52.046c-0.173,8.954-0.419,19.679-0.681,31.029c-0.933,40.809-1.988,87.063-0.905,92.487
		c0.541,2.687,0.631,17.88,0.737,35.469c0.168,28.057,0.38,62.978,2.447,68.58l0.033,0.084l0.079,0.022
		c0.134,0.039,9.077,2.726,22.951,2.726c6.982,0,15.209-0.681,24.197-2.72c0.184,0,0.184,0,0.374-3.419
		c0.111-2.072,0.268-5.038,0.457-8.59c0.369-7.111,0.855-16.59,1.341-26.068c0.966-18.958,1.921-37.921,1.921-37.921
		c0.027-0.559,2.379-56.454,1.787-79.606c0.788-17.645,4.916-34.731,4.966-34.938c0.273-7.178,1.631-25.8,4.58-26.035v0.006
		c2.882,0.151,4.246,17.89,4.575,25.481c-0.006,0.062-0.006,0.101-0.006,0.112h0.011c0.006,0.156,0.012,0.324,0.017,0.475
		c0.045,0.168,4.172,17.26,4.96,34.888c-0.592,23.164,1.765,79.059,1.787,79.623c0,0,0.955,18.957,1.921,37.915
		c0.486,9.478,0.972,18.958,1.341,26.068c0.19,3.552,0.346,6.518,0.464,8.59c0.184,3.43,0.201,3.43,0.335,3.425
		c9.004,2.044,17.249,2.72,24.237,2.72c13.885,0,22.822-2.681,22.957-2.72l0.084-0.028l0.034-0.084
		c2.072-5.607,2.279-40.529,2.446-68.585c0.107-17.589,0.202-32.776,0.738-35.469c1.083-5.424,0.028-51.673-0.905-92.481
		c-0.184-7.999-0.357-15.696-0.509-22.678c-0.061-2.921-0.122-5.714-0.173-8.357c-0.564-28.62-3.094-48.388-5.273-57.348
		c-0.279-1.139-0.452-2.055-0.552-2.893c-0.084-0.726-0.096-1.486-0.101-2.224c-0.006-0.34-0.012-0.675-0.017-1.005l-0.028-0.788
		c-0.083-2.492-0.167-5.072-0.145-7.608c0.017-1.229,0.045-2.53,0.106-4.212c0.056-1.62,0.128-3.357,0.218-5.318
		c0.1-2.089,0.207-4.178,0.324-6.267c0.128-2.346,0.268-4.692,0.413-7.038c0.151-2.553,0.313-5.105,0.48-7.652
		c0.179-2.703,0.357-5.407,0.542-8.105c0.19-2.798,0.386-5.591,0.587-8.389c0.117-1.698,0.24-3.402,0.363-5.105l0.52,1.854
		c2.446,8.815,4.764,17.143,5.569,21.555c1.167,6.452,10.266,40.049,11.629,43.847c1.609,4.497,6.072,31.118,6.128,31.414
		c0.179,0.537,0.614,0.748,0.67,0.771c1.263,0.301,3.111,0.57,5.659,0.57c4.977,0,12.629-1.033,23.839-4.904l0.128-0.045
		L-132.145,254.105z M-274.328,43.41l6.222-14.221c0.614-0.771,1.48-1.279,2.447-1.43l0.524-0.084
		c0.453-0.073,0.905-0.145,1.358-0.212c4.748-0.693,10.808-0.755,15.232-0.799c3.804-0.039,7.21,0.022,10.428,0.19
		c0.714,0.034,1.468,0.062,2.24,0.096c2.641,0.095,5.641,0.212,8.077,0.721c1.809,0.38,3.318,1.642,4.038,3.368l4.279,11.652
		c0.062,0.168,0.157,0.391,0.263,0.642c0.324,0.783,0.927,2.234,0.631,2.598c-0.061,0.078-0.195,0.095-0.39,0.055
		c-9.423-1.899-18.981-2.519-27.454-2.519c-13.567,0-24.353,1.592-27.341,2.078c-0.313,0.056-0.609-0.017-0.816-0.195
		c-0.161-0.14-0.245-0.335-0.245-0.553C-274.83,44.582-274.518,43.851-274.328,43.41 M-274.518,45.817l0.006-0.005
		c0.24,0.101,0.514,0.14,0.799,0.089c4.837-0.788,30.212-4.485,54.66,0.441c0.089,0.017,0.174,0.028,0.252,0.028
		c0.078-0.006,0.145-0.022,0.212-0.045c3.235,1.011,14.808,4.73,25.828,9.434c-1.19,4.112-14.321,51.31-22.068,153.918
		c-26.555,0.966-49.685,0.614-65.995,0.034c-7.836-103.859-21.197-150.968-22.108-154.085
		C-295.956,52.771-286.728,49.487-274.518,45.817 M-334.3,258.116c-0.123,0.374-0.408,0.531-0.408,0.536
		c-3.703,0.883-12.439,1.497-29.291-4.323c-0.006-0.006-0.011-0.033,0-0.045c-0.006,0-0.011,0.006-0.016,0.012l-0.04-0.179
		l0.179,0.011c0.262-3.994,0.559-8.244,0.922-12.668c9.926,2.899,18.41,4.374,25.219,4.374c2.145,0,4.095-0.145,5.653-0.419
		C-333.295,252.117-334.284,258.003-334.3,258.116 M-311.031,161.674c-2.345,8.406-4.77,17.098-5.524,21.231
		c-1.172,6.446-10.255,39.998-11.612,43.791c-0.848,2.368-2.479,10.803-3.848,18.338c-1.536,0.279-3.569,0.436-5.72,0.436
		c-6.792,0-15.271-1.475-25.191-4.379c0.642-7.804,1.491-16.132,2.715-24.476c0.552-3.781,1.005-7.636,1.447-11.367
		c0.229-1.955,0.457-3.916,0.704-5.87c1.854-14.841,4.155-28.252,7.037-41.004c1.028-4.563,2.195-9.183,3.324-13.651
		c1.084-4.301,2.206-8.747,3.206-13.132c2.916-12.808,6.563-25.599,10.841-38.021c2.095-6.067,4.201-11.982,7.005-17.639
		c1.251-2.525,2.569-5.01,3.926-7.552c0.123-0.229,0.319-0.531,0.519-0.844c0.413-0.636,0.899-1.39,1.129-2.061
		c0.636,3.323,3.703,19.432,6.535,36.357l0.006-0.006c0.519,5.669,2.759,30.223,4.815,55.141
		C-310.149,158.507-310.59,160.088-311.031,161.674 M-309.366,157.049l0.005-0.006h-0.005c-2.061-24.996-4.307-49.65-4.826-55.275
		h0.011c-0.011-0.039-0.017-0.073-0.022-0.112c-0.055-0.648-0.095-1.017-0.1-1.079l-0.079,0.012
		c-2.999-17.857-6.205-34.508-6.445-35.748c0.324-0.33,0.357-0.346,0.475-0.408c0.095-0.05,0.235-0.123,0.536-0.325
		c3.055-2.083,8.149-4.898,16.567-8.356c0.989,3.391,14.271,50.495,22.08,153.94c-14.383-0.52-23.37-1.206-24.6-1.308
		C-306.171,197.59-307.702,177.208-309.366,157.049 M-252.421,320.596c-0.045,0.173-4.184,17.293-4.972,34.988
		c0.593,23.152-1.759,79.031-1.781,79.59c-0.039,0.737-3.653,72.451-3.91,75.702c-25.861,5.831-45.383,0.413-46.808,0
		c-2.023-5.798-2.229-40.485-2.397-68.379c-0.106-17.611-0.201-32.816-0.743-35.536c-1.078-5.385,0.028-53.639,0.911-92.409
		c0.263-11.356,0.503-22.08,0.681-31.034c0.575-29.073,2.72-44.311,4.423-51.974c0.168-0.76,0.218-1.542,0.268-2.296
		c0.029-0.425,0.056-0.86,0.101-1.285c0.446-3.899,0.944-13.238,0.95-13.333c0.055-1.29,0.033-3.296-0.056-5.877
		c2.306,0.179,24.817,1.888,57.521,1.888h0.564v78.914c-0.966-0.212-2.374,0.156-3.569,0.95c-1.251,0.838-2.017,1.955-2.145,3.145
		c-0.285,2.676,0.854,25.599,0.904,26.576l0.068-0.006C-252.416,320.372-252.421,320.501-252.421,320.596 M-247.483,294.255
		l-0.006,0.179l-0.012-0.168c-3.1,0.163-4.345,15.702-4.758,22.941c-0.308-6.496-0.983-21.443-0.76-23.515
		c0.157-1.463,1.313-2.43,1.983-2.882c1.162-0.771,2.57-1.128,3.425-0.872l0.028,0.006l0.15-0.006
		c0.86-0.256,2.268,0.101,3.424,0.872c0.676,0.452,1.827,1.419,1.983,2.882c0.218,2-0.403,15.997-0.727,22.806
		C-243.204,308.984-244.473,294.411-247.483,294.255 M-183.377,291.875c0.151,6.982,0.324,14.678,0.508,22.683
		c0.167,7.251,0.341,14.836,0.503,22.405h-12.021l-2.686-2.145l-0.598-47.166h14.204
		C-183.438,289.026-183.41,290.44-183.377,291.875 M-188.812,226.25c2.173,8.942,4.698,28.682,5.262,57.269
		c0.022,1.229,0.05,2.497,0.078,3.787h-14.551l0.603,47.601v0.078l2.91,2.324h12.155c0.709,32.799,1.268,65.29,0.396,69.653
		c-0.542,2.72-0.637,17.924-0.743,35.536c-0.167,27.889-0.374,62.565-2.396,68.374c-1.458,0.425-20.946,5.815-46.791,0.006
		c-0.256-3.273-3.87-74.965-3.904-75.702c-0.028-0.559-2.38-56.437-1.788-79.601c-0.787-17.684-4.926-34.804-4.966-34.938
		c0-0.128-0.011-0.296-0.017-0.503c0.089-1.855,1.179-23.862,0.899-26.481c-0.128-1.19-0.888-2.307-2.144-3.145
		c-1.167-0.776-2.531-1.139-3.497-0.966v-78.897c17.002-0.017,36.698-0.497,57.7-1.888c-0.028,1.079-0.05,2-0.062,2.894
		c-0.027,2.541,0.062,5.122,0.146,7.619l0.028,0.788c0.006,0.33,0.011,0.664,0.017,0.994c0.006,0.749,0.016,1.525,0.106,2.268
		C-189.27,224.166-189.091,225.098-188.812,226.25 M-186.388,156.133c-0.207,2.838-0.408,5.676-0.608,8.513
		c-0.201,2.793-0.397,5.591-0.586,8.383c-0.184,2.704-0.364,5.407-0.542,8.105c-0.163,2.553-0.324,5.105-0.48,7.658
		c-0.146,2.346-0.279,4.692-0.414,7.043c-0.112,2.089-0.223,4.178-0.324,6.267c-0.089,1.961-0.162,3.704-0.217,5.324
		c-0.011,0.335-0.022,0.653-0.034,0.966c-8.546,0.564-16.868,0.977-24.884,1.274c7.72-102.228,20.779-149.416,22.041-153.773
		c5.944,2.548,11.702,5.374,15.869,8.216c0.307,0.202,0.446,0.274,0.536,0.325c0.123,0.061,0.151,0.078,0.475,0.408
		c-0.241,1.24-3.441,17.868-6.44,35.714l-0.073-0.039c-0.079,0.151-0.073,0.369-0.073,0.559c0,0.073,0,0.134-0.006,0.184
		l-0.028,0.369c-0.005,0.044-0.017,0.095-0.022,0.14h0.011l-1.262,15.774c-0.173,2.212-0.346,4.429-0.519,6.641
		c-0.195,2.453-0.385,4.899-0.57,7.351c-0.207,2.626-0.408,5.251-0.603,7.882c-0.213,2.753-0.419,5.502-0.62,8.256
		C-185.974,150.492-186.181,153.312-186.388,156.133 M-168.212,226.696c-1.357-3.793-10.445-37.345-11.618-43.791
		c-0.804-4.43-3.122-12.763-5.575-21.583l-0.788-2.837c0.056-0.776,0.112-1.547,0.168-2.324c0.206-2.821,0.413-5.641,0.625-8.462
		c0.201-2.754,0.408-5.508,0.62-8.256c0.196-2.631,0.397-5.257,0.598-7.881c0.189-2.452,0.379-4.899,0.57-7.351
		c0.173-2.212,0.346-4.429,0.525-6.642l1.274-15.902c2.854-17.07,5.948-33.285,6.529-36.324c0.319,0.878,1.168,2.771,2.636,6.055
		c1.263,2.821,2.832,6.329,4.408,10.004c4.568,10.657,9.154,24.097,13.266,38.87c0.486,1.754,0.977,3.503,1.463,5.251
		c3.848,13.763,7.49,26.771,10.026,40.557c1.011,5.496,1.993,11.06,2.921,16.533c0.218,1.262,0.475,2.541,0.726,3.776
		c0.419,2.083,0.855,4.233,1.089,6.362c0.302,2.743,0.565,5.535,0.821,8.233c0.492,5.123,0.994,10.418,1.76,15.629
		c1.172,8.038,2.005,16.059,2.636,23.61c-9.875,3.14-18.337,4.81-25.14,4.966c-2.145,0.05-4.172-0.061-5.725-0.307
		C-165.754,237.387-167.368,229.047-168.212,226.696 M-161.638,258.663c-0.012-0.006-0.318-0.162-0.436-0.52
		c-0.022-0.122-1.028-6.11-2.252-12.88c1.307,0.196,2.883,0.302,4.614,0.302c0.346,0,0.693-0.006,1.051-0.011
		c6.814-0.156,15.282-1.827,25.163-4.961c0.397,4.732,0.709,9.278,0.988,13.529l0.006,0.246
		C-149.283,260.143-157.979,259.534-161.638,258.663"
        />
      </g>
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M364.257,230.631c-0.118-1.798-1.899-28.694-3.52-35.167c-1.692-6.764-3.917-22.932-4.478-29.114
		c-0.572-6.248-7.852-47.67-9.544-51.615c-0.69-1.608-3.133-10.497-5.958-20.786c-3.957-14.403-8.877-32.326-10.855-36.938
		c-2.298-5.358-5.419-10.268-7.101-12.907c-0.65-1.026-1.121-1.765-1.261-2.074c-0.062-0.146-0.146-0.258-0.253-0.336l-0.174-0.129
		c-0.801-0.599-2.869-2.146-3.452-2.572c-3.957-2.892-7.897-5.257-12.049-7.235c-4.243-2.028-8.693-3.671-13.227-4.892
		c-3.609-0.97-7.263-1.816-10.872-2.522c-0.303-0.062-0.527-0.107-0.724-0.146c-0.409-0.085-0.695-0.14-1.283-0.242l0.072-0.179
		c0.398-0.981,0.023-1.99-0.308-2.875c-0.051-0.129-0.095-0.258-0.146-0.387l-4.853-11.691c-0.763-1.832-2.293-3.16-4.092-3.558
		c-2.589-0.566-5.363-0.678-8.047-0.785c-0.617-0.028-1.228-0.05-1.833-0.078c-3.407-0.168-6.876-0.235-10.301-0.208
		c-4.769,0.05-9.695,0.095-14.588,0.813c-0.454,0.067-0.908,0.14-1.367,0.213l-0.527,0.084c-1.065,0.168-2.023,0.734-2.712,1.614
		l-7.319,13.954c-0.594,0.757-0.773,1.732-0.51,2.634c-2.639,0.628-6.221,1.569-9.679,2.539c-3.228,0.908-6.479,1.899-9.662,2.947
		l-0.174,0.056c-2.953,0.975-6.002,1.978-8.832,3.391c-6.439,3.222-13.102,8.748-13.102,9.505c-0.029,0.173-0.617,1.093-1.295,2.157
		c-1.676,2.64-4.803,7.549-7.101,12.907c-1.972,4.612-6.899,22.535-10.856,36.938c-2.825,10.289-5.262,19.178-5.957,20.786
		c-1.687,3.945-8.973,45.367-9.538,51.615c-0.566,6.182-2.792,22.351-4.478,29.114c-0.941,3.755-1.933,14.381-2.628,22.995v0.006
		c-0.499,6.232-0.841,11.41-0.891,12.166c-0.073,0.062-0.123,0.152-0.128,0.258c-0.012,0.174,0.078,0.326,0.235,0.375
		c10.451,3.61,17.58,4.579,22.227,4.579c2.376,0,4.096-0.258,5.279-0.538c0.336-0.078,0.571-0.375,0.622-0.751h0.017
		c0.067-0.37,6.938-37.375,8.44-41.567c1.267-3.542,9.752-34.859,10.844-40.878c0.869-4.786,3.688-18.545,6.607-26.766
		c0.034,7.348,0.336,40.01,0.336,40.351l-0.806,39.835c0.016,1.194-0.107,2.382-0.365,3.537c-1.709,7.706-3.873,23.016-4.444,52.221
		c-0.18,8.983-0.426,19.744-0.684,31.131c-0.936,40.945-1.995,87.355-0.907,92.797c0.537,2.695,0.627,17.939,0.734,35.587
		c0.168,28.15,0.381,63.189,2.46,68.815l0.034,0.084l0.085,0.022c0.134,0.045,9.107,2.741,23.028,2.741
		c7.005,0,15.266-0.684,24.277-2.729c0.191,0,0.191,0,0.382-3.441c0.117-2.08,0.274-5.056,0.459-8.62
		c0.375-7.134,0.863-16.644,1.351-26.155c0.97-19.02,1.928-38.048,1.928-38.048c0.022-0.565,2.382-56.642,1.793-79.872
		c0.785-17.698,4.932-34.848,4.977-35.054c0.138-3.632,0.553-10.184,1.31-15.817h0.039v-0.286c0.743-5.419,1.807-9.917,3.252-10.013
		c2.886,0.19,4.254,17.961,4.579,25.567c-0.006,0.061-0.006,0.1-0.006,0.106h0.011c0.006,0.163,0.012,0.325,0.017,0.477
		c0.045,0.173,4.191,17.317,4.976,35.01c-0.594,23.242,1.771,79.318,1.794,79.884c0,0,0.958,19.027,1.927,38.048
		c0.488,9.511,0.975,19.022,1.351,26.155c0.185,3.564,0.342,6.54,0.46,8.62c0.185,3.429,0.179,3.429,0.336,3.435
		c9.034,2.045,17.306,2.729,24.318,2.729c13.932,0,22.899-2.691,23.033-2.735l0.085-0.022l0.033-0.084
		c2.079-5.627,2.287-40.671,2.455-68.821c0.107-17.648,0.202-32.887,0.74-35.582c1.087-5.442,0.027-51.845-0.908-92.79
		c-0.185-8.031-0.358-15.748-0.51-22.753c-0.062-2.931-0.123-5.733-0.173-8.384c-0.567-28.717-3.105-48.55-5.291-57.539
		c-0.572-2.349-0.801-4.814-0.683-7.32h-0.006l-0.174-0.011h0.185l-0.6-31.373v-41.27c1.978,5.654,4.254,15.4,6.607,28.335
		c1.093,6.019,9.572,37.336,10.839,40.878c1.503,4.191,8.373,41.197,8.446,41.567h0.012c0.055,0.376,0.291,0.673,0.627,0.751
		c1.177,0.28,2.903,0.538,5.279,0.538c4.64,0,11.775-0.969,22.227-4.579c0.151-0.05,0.247-0.201,0.235-0.375
		C364.38,230.783,364.33,230.694,364.257,230.631z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M311.369,221.394l-37.016-42.813c0,0-4.883,5.729-5.922,7.531l43.563,49.172L311.369,221.394z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M192.854,221.435l37.016-42.813c0,0,4.883,5.729,5.922,7.531l-43.563,49.172L192.854,221.435z"
        />
        <polygon
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          points="262.828,71.558 305.766,71.558 305.766,84.743 300.516,90.386 268.266,90.386 262.828,84.651 	"
        />
        <polygon
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          points="197.714,71.622 240.651,71.622 240.651,84.808 235.401,90.45 203.151,90.45 197.714,84.716 	"
        />
        <rect x="251.535" y="217.783" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.536" y="216.925" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.536" y="216.065" fill="#010101" width="1.288" height="0.371" />
        <rect x="251.008" y="217.358" fill="#010101" width="1.288" height="0.371" />
        <rect x="251.009" y="216.5" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.009" y="215.641" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.532" y="224.659" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.533" y="223.801" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.533" y="222.942" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.533" y="222.083" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.534" y="221.224" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.534" y="220.366" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.534" y="219.507" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.534" y="218.648" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.005" y="224.234" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.005" y="223.376" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.006" y="222.517" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.006" y="221.658" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.007" y="220.799" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.007" y="219.94" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.008" y="219.082" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.008" y="218.223" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.529" y="231.534" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.529" y="230.675" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.529" y="229.816" fill="#010101" width="1.288" height="0.37" />
        <rect x="251.53" y="228.957" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.531" y="228.098" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.531" y="227.24" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.531" y="226.381" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.532" y="225.522" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.002" y="231.109" fill="#010101" width="1.288" height="0.37" />
        <rect x="251.002" y="230.25" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.003" y="229.391" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.004" y="228.533" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.004" y="227.674" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.004" y="226.815" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.004" y="225.956" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.005" y="225.097" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.525" y="238.399" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.526" y="237.54" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.527" y="236.681" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.527" y="235.822" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.527" y="234.964" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.527" y="234.105" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.528" y="233.246" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.528" y="232.387" fill="#010101" width="1.287" height="0.371" />
        <rect x="250.999" y="237.974" fill="#010101" width="1.287" height="0.37" />
        <rect x="250.999" y="237.115" fill="#010101" width="1.287" height="0.371" />
        <rect x="250.999" y="236.256" fill="#010101" width="1.287" height="0.37" />
        <rect x="251" y="235.398" fill="#010101" width="1.287" height="0.37" />
        <rect x="251" y="234.539" fill="#010101" width="1.287" height="0.37" />
        <rect x="251" y="233.68" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.001" y="232.821" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.001" y="231.963" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.576" y="132.684" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.576" y="131.826" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.576" y="130.967" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.049" y="132.26" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.049" y="131.4" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.05" y="130.542" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.572" y="139.561" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.573" y="138.702" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.573" y="137.843" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.574" y="136.984" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.574" y="136.125" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.574" y="135.266" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.575" y="134.408" fill="#010101" width="1.286" height="0.371" />
        <rect x="251.575" y="133.549" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.045" y="139.136" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.046" y="138.277" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.046" y="137.418" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.046" y="136.559" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.047" y="135.701" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.048" y="134.842" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.048" y="133.983" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.048" y="133.124" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.569" y="146.435" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.57" y="145.576" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.57" y="144.717" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.57" y="143.858" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.571" y="142.999" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.571" y="142.141" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.571" y="141.282" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.572" y="140.424" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.042" y="146.009" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.043" y="145.151" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.043" y="144.292" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.043" y="143.433" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.044" y="142.574" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.044" y="141.716" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.045" y="140.857" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.045" y="139.998" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.566" y="153.3" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.566" y="152.441" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.566" y="151.583" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.567" y="150.723" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.567" y="149.865" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.568" y="149.006" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.568" y="148.147" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.569" y="147.289" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.039" y="152.875" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.04" y="152.017" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.039" y="151.157" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.04" y="150.298" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.04" y="149.44" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.041" y="148.581" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.042" y="147.722" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.042" y="146.863" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.563" y="160.168" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.563" y="159.309" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.564" y="158.45" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.564" y="157.591" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.564" y="156.733" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.565" y="155.874" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.565" y="155.015" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.565" y="154.156" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.036" y="159.742" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.036" y="158.884" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.036" y="158.025" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.037" y="157.166" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.037" y="156.307" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.038" y="155.449" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.038" y="154.59" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.038" y="153.731" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.559" y="167.044" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.56" y="166.185" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.56" y="165.326" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.56" y="164.467" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.561" y="163.609" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.561" y="162.75" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.562" y="161.891" fill="#010101" width="1.288" height="0.37" />
        <rect x="251.562" y="161.032" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.032" y="166.619" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.033" y="165.76" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.033" y="164.901" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.033" y="164.042" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.034" y="163.184" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.034" y="162.325" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.035" y="161.466" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.035" y="160.607" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.556" y="173.918" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.557" y="173.06" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.557" y="172.2" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.557" y="171.342" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.558" y="170.483" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.558" y="169.624" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.559" y="168.765" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.559" y="167.907" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.029" y="173.493" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.03" y="172.634" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.03" y="171.775" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.03" y="170.917" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.031" y="170.058" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.031" y="169.199" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.032" y="168.34" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.032" y="167.482" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.553" y="180.798" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.553" y="179.939" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.553" y="179.08" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.554" y="178.221" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.554" y="177.363" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.555" y="176.504" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.555" y="175.645" fill="#010101" width="1.288" height="0.37" />
        <rect x="251.556" y="174.786" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.026" y="180.373" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.026" y="179.514" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.027" y="178.655" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.027" y="177.796" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.027" y="176.938" fill="#010101" width="1.288" height="0.37" />
        <rect x="251.028" y="176.078" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.029" y="175.219" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.029" y="174.361" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.55" y="187.665" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.55" y="186.806" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.55" y="185.948" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.551" y="185.089" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.551" y="184.23" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.552" y="183.372" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.552" y="182.512" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.552" y="181.654" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.023" y="187.24" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.023" y="186.381" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.024" y="185.523" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.024" y="184.664" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.024" y="183.805" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.025" y="182.946" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.025" y="182.088" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.025" y="181.229" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.546" y="194.542" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.547" y="193.683" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.547" y="192.824" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.547" y="191.965" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.548" y="191.107" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.548" y="190.248" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.549" y="189.389" fill="#010101" width="1.288" height="0.371" />
        <rect x="251.549" y="188.53" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.019" y="194.116" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.02" y="193.257" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.02" y="192.399" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.02" y="191.54" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.021" y="190.681" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.021" y="189.822" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.022" y="188.963" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.022" y="188.105" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.543" y="201.415" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.543" y="200.557" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.544" y="199.698" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.544" y="198.839" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.545" y="197.98" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.545" y="197.122" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.545" y="196.263" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.546" y="195.404" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.016" y="200.991" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.017" y="200.132" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.017" y="199.273" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.018" y="198.415" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.018" y="197.555" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.018" y="196.697" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.019" y="195.838" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.019" y="194.979" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.539" y="208.281" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.54" y="207.422" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.541" y="206.563" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.541" y="205.705" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.541" y="204.846" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.542" y="203.987" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.542" y="203.128" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.543" y="202.269" fill="#010101" width="1.288" height="0.371" />
        <rect x="251.013" y="207.856" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.013" y="206.997" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.014" y="206.138" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.014" y="205.28" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.014" y="204.42" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.014" y="203.562" fill="#010101" width="1.288" height="0.371" />
        <rect x="251.016" y="202.703" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.016" y="201.845" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.537" y="215.148" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.537" y="214.289" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.538" y="213.431" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.538" y="212.572" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.538" y="211.714" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.539" y="210.854" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.539" y="209.996" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.539" y="209.137" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.01" y="214.724" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.01" y="213.865" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.011" y="213.006" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.011" y="212.147" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.011" y="211.288" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.012" y="210.429" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.012" y="209.571" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.013" y="208.712" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.616" y="47.586" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.616" y="46.726" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.617" y="45.867" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.089" y="47.16" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.089" y="46.302" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.09" y="45.443" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.616" y="45.016" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.616" y="44.157" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.617" y="43.298" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.089" y="44.591" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.089" y="43.732" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.09" y="42.873" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.588" y="42.446" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.589" y="41.588" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.589" y="40.729" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.061" y="42.021" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.062" y="41.162" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.062" y="40.304" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.612" y="54.462" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.613" y="53.603" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.614" y="52.744" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.614" y="51.885" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.614" y="51.026" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.615" y="50.168" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.615" y="49.309" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.615" y="48.45" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.086" y="54.036" fill="#010101" width="1.288" height="0.371" />
        <rect x="251.086" y="53.178" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.087" y="52.319" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.087" y="51.46" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.087" y="50.601" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.088" y="49.743" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.088" y="48.884" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.089" y="48.025" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.609" y="61.336" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.61" y="60.477" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.61" y="59.618" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.61" y="58.759" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.611" y="57.901" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.611" y="57.042" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.612" y="56.184" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.612" y="55.324" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.082" y="60.911" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.083" y="60.052" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.083" y="59.193" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.084" y="58.334" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.084" y="57.476" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.084" y="56.617" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.085" y="55.758" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.085" y="54.899" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.606" y="68.201" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.606" y="67.342" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.607" y="66.483" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.607" y="65.624" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.608" y="64.766" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.608" y="63.907" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.609" y="63.048" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.609" y="62.19" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.079" y="67.776" fill="#010101" width="1.288" height="0.37" />
        <rect x="251.08" y="66.917" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.08" y="66.058" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.08" y="65.2" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.081" y="64.341" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.081" y="63.482" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.082" y="62.623" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.082" y="61.764" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.603" y="75.068" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.603" y="74.21" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.604" y="73.351" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.604" y="72.492" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.604" y="71.633" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.605" y="70.774" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.605" y="69.916" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.605" y="69.057" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.076" y="74.644" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.076" y="73.785" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.077" y="72.926" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.077" y="72.067" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.078" y="71.209" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.078" y="70.35" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.078" y="69.491" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.079" y="68.632" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.599" y="81.945" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.6" y="81.086" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.6" y="80.228" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.601" y="79.369" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.601" y="78.51" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.602" y="77.651" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.602" y="76.792" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.602" y="75.933" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.073" y="81.52" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.073" y="80.661" fill="#010101" width="1.288" height="0.37" />
        <rect x="251.074" y="79.802" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.074" y="78.944" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.074" y="78.085" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.075" y="77.226" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.075" y="76.367" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.076" y="75.509" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.596" y="88.819" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.597" y="87.96" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.597" y="87.102" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.598" y="86.243" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.598" y="85.384" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.598" y="84.525" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.599" y="83.667" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.599" y="82.807" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.069" y="88.394" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.07" y="87.535" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.07" y="86.677" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.071" y="85.817" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.071" y="84.959" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.071" y="84.1" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.071" y="83.241" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.072" y="82.382" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.593" y="95.699" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.593" y="94.84" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.594" y="93.981" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.594" y="93.123" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.595" y="92.263" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.595" y="91.405" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.596" y="90.546" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.596" y="89.687" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.066" y="95.274" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.066" y="94.415" fill="#010101" width="1.288" height="0.37" />
        <rect x="251.067" y="93.556" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.068" y="92.698" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.068" y="91.839" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.068" y="90.98" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.069" y="90.121" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.069" y="89.262" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.59" y="102.566" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.59" y="101.708" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.591" y="100.849" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.591" y="99.99" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.591" y="99.132" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.592" y="98.272" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.592" y="97.414" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.593" y="96.555" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.063" y="102.141" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.064" y="101.283" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.064" y="100.423" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.064" y="99.565" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.064" y="98.706" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.065" y="97.847" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.065" y="96.989" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.065" y="96.13" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.587" y="109.442" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.587" y="108.584" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.587" y="107.725" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.588" y="106.866" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.588" y="106.007" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.589" y="105.148" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.589" y="104.289" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.589" y="103.431" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.059" y="109.017" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.06" y="108.159" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.061" y="107.3" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.061" y="106.441" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.061" y="105.582" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.062" y="104.724" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.062" y="103.865" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.062" y="103.006" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.584" y="116.317" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.584" y="115.458" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.584" y="114.599" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.585" y="113.74" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.585" y="112.882" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.585" y="112.023" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.586" y="111.164" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.586" y="110.305" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.056" y="115.892" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.057" y="115.033" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.057" y="114.174" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.057" y="113.316" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.058" y="112.457" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.059" y="111.598" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.059" y="110.739" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.059" y="109.88" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.58" y="123.182" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.58" y="122.323" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.58" y="121.465" fill="#010101" width="1.288" height="0.37" />
        <rect x="251.581" y="120.605" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.582" y="119.747" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.582" y="118.888" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.583" y="118.029" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.583" y="117.171" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.053" y="122.757" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.054" y="121.898" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.054" y="121.039" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.055" y="120.18" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.055" y="119.322" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.055" y="118.463" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.056" y="117.604" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.056" y="116.745" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.577" y="130.049" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.577" y="129.191" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.578" y="128.332" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.578" y="127.473" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.579" y="126.615" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.579" y="125.756" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.579" y="124.897" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.579" y="124.038" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.05" y="129.624" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.05" y="128.765" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.051" y="127.907" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.051" y="127.048" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.051" y="126.189" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.052" y="125.331" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.052" y="124.472" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.053" y="123.613" fill="#010101" width="1.287" height="0.371" />
        <path
          fill="#010101"
          d="M252.707,34.436c-0.005-0.148-0.131-0.271-0.278-0.271h-0.005v0.285h0.047l0.104,1.282h-1.147l0.106-1.282
		h0.047v-0.285h-0.022c-0.15,0-0.275,0.123-0.279,0.271l-0.165,5.359c-0.004,0.149,0.113,0.271,0.263,0.271h1.237
		c0.15,0,0.267-0.123,0.263-0.271L252.707,34.436z M251.479,36.655c0-0.101,0.082-0.181,0.181-0.181h0.676
		c0.099,0,0.18,0.08,0.18,0.181v0.675c0,0.101-0.082,0.18-0.181,0.18h-0.676c-0.099,0-0.18-0.08-0.18-0.18V36.655z M251.998,39.757
		c-0.33,0-0.597-0.267-0.596-0.597c0-0.328,0.267-0.596,0.597-0.596c0.33,0,0.597,0.268,0.597,0.596
		C252.595,39.49,252.328,39.757,251.998,39.757"
        />
        <rect x="251.687" y="33.36" fill="#010101" width="0.632" height="1.557" />
        <path
          fill="#010101"
          d="M253.371,33.747c0.001-0.717-0.581-1.3-1.297-1.3h-0.14c-0.718,0-1.299,0.582-1.3,1.3
		c0,0.133,0.02,0.262,0.058,0.383c0,0.001,0.001,0.002,0.001,0.003c0.001,0,0.001,0.001,0.001,0.001
		c0.128,0.339,0.127,0.833,0.127,1.305h0.003c0.016,0.259,0.14,0.49,0.327,0.648l0.056-1.755c0.006-0.155,0.144-0.281,0.308-0.281
		h0.068l0.001-0.801h0.842l-0.001,0.801h0.049c0.164,0,0.303,0.126,0.308,0.281l0.061,1.765c0.193-0.159,0.322-0.393,0.339-0.659
		h0.002v-0.038c0-0.007,0.001-0.014,0.001-0.021c0-0.007-0.001-0.013-0.001-0.02c0.001-0.438,0.007-0.884,0.12-1.203
		C253.347,34.028,253.371,33.891,253.371,33.747"
        />
        <rect x="251.132" y="238.891" fill="#010101" width="1.645" height="0.727" />
        <path
          fill="#010101"
          d="M252.201,241.911h-0.497c-0.528,0-0.956-0.428-0.956-0.956l0.001-1.212h2.408l-0.001,1.212
		C253.157,241.483,252.729,241.911,252.201,241.911"
        />
        <path
          fill={darkenColor}
          d="M166.672,234.459c-0.017,0.202-0.118,0.437-0.359,0.493c-3.452,0.824-11.584,1.396-27.276-4.046
		c3.206-0.645,14.437-2.287,27.327,2.965C166.616,233.977,166.688,234.252,166.672,234.459"
        />
        <path
          fill={darkenColor}
          d="M364.033,230.912v0.012c-15.72,5.424-23.852,4.853-27.304,4.029c-0.246-0.056-0.348-0.291-0.364-0.493
		c-0.016-0.207,0.056-0.482,0.309-0.588c7.235-2.947,13.943-3.721,19.004-3.721C359.673,230.15,362.638,230.632,364.033,230.912"
        />
        <path
          fill={darkenColor}
          d="M265.437,19.389c-1.643,3.076-7.672,7.947-11.343,10.34c-0.028,0.016-0.039,0.039-0.056,0.062
		c-0.006,0.005-0.011,0.017-0.017,0.022c-0.011,0.017-0.028,0.034-0.039,0.056c-0.157,0.263-0.084,0.611-0.017,0.902
		c0.028,0.145,0.062,0.285,0.062,0.398c0.005,0.247,0.011,0.488,0.022,0.728c0.011,0.354,0.022,0.707,0.022,1.054
		c0.005,1.277-0.05,2.567-0.168,3.828c-0.134,1.356-0.197,2.561-0.197,3.688v196.605l0.006,2.539
		c0.006,0.235,0.028,0.857-0.135,1.087c-0.342,0.33-0.835,0.65-1.026,0.622c-0.028,0-0.623-0.062-0.908-0.039
		c-0.185,0.011-0.493-0.062-0.583-0.095c-0.308-0.112-0.65-0.465-0.656-0.465c-0.179-0.258-0.163-0.88-0.151-1.11v-0.628
		c0.006-20.327,0.017-198.628,0-199.726c-0.006-0.527-0.056-1.054-0.101-1.57l-0.033-0.403c-0.107-1.267-0.174-2.561-0.207-3.833
		c-0.016-0.639-0.028-1.283-0.022-1.922c0-0.073,0.056-0.269,0.112-0.443c0.123-0.398,0.263-0.869,0.151-1.154
		c-0.011-0.045-0.039-0.084-0.072-0.118c-0.017-0.017-0.039-0.028-0.056-0.045c-3.581-2.326-9.337-6.944-11.237-10.065
		C240.29,19.372,249.044,17.701,265.437,19.389"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M139.71,219.754c0,0,5.957-1.128,10.819-0.874c0,0,10.88,0.216,18.551,4.82"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M363.213,219.587c0,0-5.957-1.128-10.819-0.874c0,0-10.88,0.216-18.551,4.82"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M253.55,243.524c0.488-0.031,0.973-0.059,1.462-0.087c0.492-0.028,0.957-0.174,1.337-0.496c0.125-0.106,0.312-0.754,0.374-0.907
		c0.068-0.166-0.015,0.174,0,0c0.018-0.207,0.029-0.414,0.036-0.622c0.014-0.407,0.016-0.817,0.012-1.224
		c-0.001-0.16-0.006-0.319-0.006-0.479v-0.074v-0.283v-0.491v-0.693v-0.888v-1.078v-1.262c0-0.481-0.001-0.961-0.001-1.441v-1.612
		v-1.779v-1.939c-0.001-0.698-0.001-1.396-0.001-2.094v-2.242v-2.385c-0.001-0.841-0.001-1.681-0.001-2.522v-2.652
		c0-0.926-0.001-1.852-0.001-2.778v-2.897c0-1.004,0-2.007-0.001-3.011v-3.119v-3.22c-0.001-1.105-0.001-2.21-0.001-3.316v-3.405
		c-0.001-1.163-0.001-2.326-0.001-3.489v-3.568c0-1.213,0-2.426,0-3.639v-3.706c0-1.255-0.001-2.511-0.001-3.767v-3.821
		c0-1.29,0-2.58-0.001-3.869v-3.913v-3.949c-0.001-1.327-0.001-2.653-0.001-3.98v-4.005c0-1.342-0.001-2.683-0.001-4.024v-4.038
		v-4.046c-0.001-1.349-0.001-2.698-0.001-4.047v-4.043v-4.033c0-1.339-0.001-2.678-0.001-4.017v-3.995v-3.967v-3.934v-3.894
		c-0.001-1.283-0.001-2.566-0.001-3.848v-3.797v-3.74v-3.678v-3.608v-3.534v-3.453v-3.367c0-1.091,0-2.182,0.001-3.273v-3.175
		v-3.071v-2.961c0-0.949,0.001-1.897,0.001-2.846v-2.723c0-0.865,0-1.731,0.001-2.595v-2.462c0-0.774,0-1.548,0.001-2.322v-2.177
		c0-0.675,0.001-1.351,0.001-2.026c0-0.623,0-1.246,0.001-1.868v-1.705c0.001-0.512,0.001-1.024,0.001-1.537
		c0-0.454,0-0.908,0-1.362c0.001-0.393,0.001-0.787,0.001-1.181c0.001-0.332,0.001-0.664,0.001-0.995
		c0.001-0.267,0.001-0.535,0.001-0.803c0.001-1.229,0.076-2.445,0.193-3.667c0.122-1.277,0.179-2.561,0.174-3.843
		c-0.002-0.597-0.035-1.191-0.048-1.787"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M247.031,31.871c-0.001,0.642-0.034,0.903-0.017,1.546c0.033,1.283,0.103,2.566,0.21,3.846c0.054,0.653,0.123,1.304,0.134,1.96
		c0.019,1.162,0,201.734,0,201.921c0,0.326,0.053,1.32,0.148,1.636c0.076,0.252,0.449,0.298,0.667,0.344
		c1.13,0.242,2.282,0.411,3.433,0.502"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M238.509,18.74c0,0,8.776-2.275,27.217-0.347"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M278.665,22.169l-0.525,1.233c-1.729,4.265-5.57,13.732-8.132,17.176c-0.475-0.427-1.062-0.975-1.732-1.599l-0.049-0.047
		c-3.282-3.058-7.956-7.414-11.788-9.301"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M247.636,29.633c-3.833,1.888-8.507,6.244-11.784,9.299c-0.716,0.667-1.322,1.23-1.802,1.661
		c-2.586-3.238-7.782-13.73-10.224-18.87"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.6933,0.5201"
          d="
		M188.351,482.297c0,0,21.535,6.351,48.775,0.177"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.6933,0.5201"
          d="
		M315.98,482.297c0,0-21.653,6.351-48.893,0.177"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.5201,0.5201"
          d="
		M256.512,289.136c0.281-6.124,0.673-15.537,0.511-17.048c-0.244-2.27-3.32-3.721-4.754-3.293h-0.063
		c-1.434-0.428-4.509,1.022-4.754,3.293c-0.16,1.491,0.22,10.675,0.499,16.802"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.5201,0.5201"
          d="
		M248.788,282.727v-8.493c0-1.092,0.407-2.155,1.177-2.929c0.53-0.532,1.195-0.82,2.157-0.83"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.5201,0.5201"
          d="
		M255.661,282.801l-0.118-8.611c0-1.091-0.407-2.155-1.177-2.929c-0.53-0.531-1.195-0.819-2.157-0.829"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.6776,0.677"
          x1="252.815"
          y1="242.198"
          x2="252.815"
          y2="266.608"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M193.566,231.706c0.155-3.824,0.393-9.778,0.393-9.778"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M195.243,230.065c0.155-3.824,0.393-9.778,0.393-9.778"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M229.724,180.553c0.967,1.147,2.521,3.06,4.228,5.437"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M228.466,181.778c0.967,1.147,2.521,3.06,4.228,5.437"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M235.641,188.194c2.696,4.009,4.773,7.846,6.181,11.424c1.795,5.042,1.429,9.42,1.412,9.604l-0.004,0.08l-0.96,47.439l-5.99,5.717
		h-39.448c-2.501-1.576-4.362-3.462-4.281-4.361c0.129-1.384,0.559-11.473,1.007-22.27"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M234.421,189.574c2.053,3.246,4.689,7.745,5.836,10.66c1.658,4.661,1.306,8.793,1.302,8.834l-0.011,0.2l-0.947,46.739l-4.997,4.77
		h-38.277c-1.789-1.188-2.829-2.297-3.084-2.752c0.148-2.017,0.55-14.06,0.969-24.15"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          x1="195.939"
          y1="246.191"
          x2="239.091"
          y2="245.83"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          x1="196.602"
          y1="222.517"
          x2="229.149"
          y2="184.849"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M310.648,231.706c-0.155-3.824-0.393-9.778-0.393-9.778"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M308.971,230.065c-0.155-3.824-0.393-9.778-0.393-9.778"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M274.49,180.553c-0.967,1.147-2.521,3.06-4.228,5.437"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M275.749,181.778c-0.967,1.147-2.521,3.06-4.228,5.437"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M268.573,188.194c-2.696,4.009-4.773,7.846-6.181,11.424c-1.795,5.042-1.429,9.42-1.412,9.604l0.004,0.08l0.96,47.439l5.99,5.717
		h39.448c2.501-1.576,4.362-3.462,4.281-4.361c-0.129-1.384-0.559-11.473-1.007-22.27"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          d="
		M269.793,189.574c-2.053,3.246-4.689,7.745-5.836,10.66c-1.658,4.661-1.306,8.793-1.302,8.834l0.011,0.2l0.947,46.739l4.997,4.77
		h38.277c1.789-1.188,2.829-2.297,3.084-2.752c-0.148-2.017-0.55-14.06-0.969-24.15"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          x1="308.276"
          y1="246.191"
          x2="265.123"
          y2="245.83"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          x1="307.612"
          y1="222.517"
          x2="275.066"
          y2="184.849"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          points="
		237.633,89.328 237.633,122.095 233.386,126.341 205.009,126.341 200.762,122.095 200.762,89.284 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          points="
		239.314,87.058 239.314,122.095 239.314,122.791 238.821,123.284 234.575,127.53 234.082,128.023 233.386,128.023 205.008,128.023 
		204.312,128.023 203.819,127.53 199.573,123.284 199.08,122.791 199.08,122.095 199.08,87.058 	"
        />
        <polygon
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          points="
		204.083,87.98 200.127,83.778 200.127,73.963 238.309,73.963 238.309,83.778 234.354,87.98 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          x1="200.127"
          y1="73.963"
          x2="198.138"
          y2="73.963"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          x1="238.309"
          y1="73.963"
          x2="240.058"
          y2="73.963"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          points="
		265.957,89.328 265.957,122.095 270.203,126.341 298.581,126.341 302.827,122.095 302.827,89.284 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          points="
		264.275,87.058 264.275,122.095 264.275,122.791 264.768,123.284 269.014,127.53 269.507,128.023 270.203,128.023 298.581,128.023 
		299.277,128.023 299.77,127.53 304.016,123.284 304.508,122.791 304.508,122.095 304.508,87.058 	"
        />
        <polygon
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          points="
		299.507,87.98 303.462,83.778 303.462,73.963 265.28,73.963 265.28,83.778 269.235,87.98 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          x1="303.462"
          y1="73.963"
          x2="305.45"
          y2="73.963"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2522"
          strokeMiterlimit="10"
          strokeDasharray="0.7527,0.7521"
          x1="265.28"
          y1="73.963"
          x2="263.531"
          y2="73.963"
        />
        <rect x="251.535" y="217.394" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.536" y="216.536" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.536" y="215.677" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.008" y="216.969" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.009" y="216.11" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.009" y="215.252" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.532" y="224.27" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.533" y="223.412" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.533" y="222.553" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.533" y="221.694" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.534" y="220.835" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.534" y="219.977" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.534" y="219.118" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.535" y="218.259" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.005" y="223.845" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.005" y="222.986" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.006" y="222.128" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.006" y="221.269" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.007" y="220.41" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.007" y="219.552" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.008" y="218.693" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.008" y="217.834" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.529" y="231.144" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.529" y="230.286" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.53" y="229.427" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.53" y="228.568" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.53" y="227.71" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.531" y="226.851" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.531" y="225.992" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.532" y="225.133" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.002" y="230.719" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.002" y="229.861" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.003" y="229.002" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.003" y="228.143" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.004" y="227.284" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.004" y="226.426" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.004" y="225.567" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.005" y="224.708" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.525" y="238.01" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.526" y="237.151" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.527" y="236.292" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.527" y="235.434" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.527" y="234.575" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.528" y="233.716" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.528" y="232.857" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.528" y="231.998" fill="#010101" width="1.287" height="0.371" />
        <rect x="250.999" y="237.585" fill="#010101" width="1.287" height="0.371" />
        <rect x="250.999" y="236.726" fill="#010101" width="1.287" height="0.371" />
        <rect x="250.999" y="235.867" fill="#010101" width="1.287" height="0.371" />
        <rect x="251" y="235.008" fill="#010101" width="1.287" height="0.371" />
        <rect x="251" y="234.15" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.001" y="233.291" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.001" y="232.432" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.001" y="231.574" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.575" y="132.295" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.576" y="131.436" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.576" y="130.578" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.049" y="131.87" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.049" y="131.011" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.05" y="130.153" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.572" y="139.172" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.573" y="138.313" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.573" y="137.454" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.574" y="136.596" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.574" y="135.736" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.574" y="134.877" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.575" y="134.019" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.575" y="133.16" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.045" y="138.746" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.046" y="137.888" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.046" y="137.029" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.047" y="136.17" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.047" y="135.311" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.047" y="134.453" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.048" y="133.594" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.048" y="132.735" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.569" y="146.046" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.569" y="145.187" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.57" y="144.328" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.57" y="143.469" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.571" y="142.611" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.571" y="141.752" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.571" y="140.893" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.572" y="140.034" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.042" y="145.62" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.043" y="144.762" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.043" y="143.903" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.043" y="143.044" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.044" y="142.185" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.045" y="141.327" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.045" y="140.468" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.045" y="139.609" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.566" y="152.911" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.566" y="152.052" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.566" y="151.193" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.567" y="150.335" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.567" y="149.476" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.568" y="148.617" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.568" y="147.758" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.569" y="146.899" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.039" y="152.486" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.04" y="151.627" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.04" y="150.768" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.04" y="149.909" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.04" y="149.051" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.041" y="148.192" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.041" y="147.333" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.042" y="146.474" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.562" y="159.779" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.563" y="158.92" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.563" y="158.061" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.564" y="157.202" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.564" y="156.344" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.565" y="155.485" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.565" y="154.626" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.565" y="153.767" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.036" y="159.354" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.036" y="158.495" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.036" y="157.636" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.037" y="156.777" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.037" y="155.918" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.038" y="155.06" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.038" y="154.201" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.039" y="153.342" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.56" y="166.654" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.56" y="165.796" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.56" y="164.937" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.56" y="164.078" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.561" y="163.22" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.561" y="162.361" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.562" y="161.502" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.562" y="160.644" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.032" y="166.23" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.033" y="165.371" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.033" y="164.512" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.034" y="163.653" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.034" y="162.794" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.034" y="161.936" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.035" y="161.077" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.035" y="160.218" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.556" y="173.529" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.557" y="172.67" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.557" y="171.811" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.557" y="170.952" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.558" y="170.094" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.558" y="169.235" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.559" y="168.376" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.559" y="167.518" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.029" y="173.104" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.03" y="172.245" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.03" y="171.387" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.03" y="170.528" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.031" y="169.668" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.031" y="168.81" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.032" y="167.951" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.032" y="167.092" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.553" y="180.409" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.553" y="179.55" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.554" y="178.691" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.554" y="177.832" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.554" y="176.973" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.555" y="176.115" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.555" y="175.256" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.556" y="174.397" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.026" y="179.983" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.026" y="179.125" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.027" y="178.266" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.027" y="177.407" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.027" y="176.549" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.028" y="175.69" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.028" y="174.831" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.029" y="173.972" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.549" y="187.276" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.55" y="186.417" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.55" y="185.559" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.551" y="184.7" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.551" y="183.841" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.552" y="182.983" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.552" y="182.124" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.552" y="181.265" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.023" y="186.851" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.023" y="185.992" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.023" y="185.134" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.024" y="184.275" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.024" y="183.416" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.025" y="182.557" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.025" y="181.699" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.025" y="180.84" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.546" y="194.152" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.547" y="193.293" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.547" y="192.435" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.548" y="191.576" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.548" y="190.717" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.548" y="189.859" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.549" y="189" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.549" y="188.141" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.019" y="193.728" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.02" y="192.869" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.02" y="192.009" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.021" y="191.151" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.021" y="190.292" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.021" y="189.433" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.022" y="188.575" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.022" y="187.716" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.543" y="201.026" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.543" y="200.168" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.544" y="199.309" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.544" y="198.45" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.545" y="197.591" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.545" y="196.733" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.545" y="195.874" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.546" y="195.015" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.016" y="200.602" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.016" y="199.743" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.017" y="198.884" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.018" y="198.025" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.018" y="197.166" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.018" y="196.307" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.019" y="195.449" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.019" y="194.59" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.539" y="207.891" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.54" y="207.033" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.541" y="206.174" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.541" y="205.315" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.541" y="204.457" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.542" y="203.598" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.542" y="202.739" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.543" y="201.881" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.013" y="207.467" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.013" y="206.608" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.014" y="205.749" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.014" y="204.89" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.014" y="204.031" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.015" y="203.173" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.015" y="202.314" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.016" y="201.455" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.536" y="214.76" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.537" y="213.901" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.537" y="213.042" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.538" y="212.183" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.538" y="211.324" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.539" y="210.465" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.539" y="209.607" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.539" y="208.748" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.01" y="214.334" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.01" y="213.476" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.01" y="212.617" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.011" y="211.758" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.011" y="210.9" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.012" y="210.041" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.012" y="209.182" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.013" y="208.323" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.616" y="47.196" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.616" y="46.338" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.617" y="45.479" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.089" y="46.771" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.089" y="45.912" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.09" y="45.054" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.616" y="44.627" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.616" y="43.768" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.617" y="42.909" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.089" y="44.202" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.089" y="43.343" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.09" y="42.484" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.588" y="42.057" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.588" y="41.199" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.589" y="40.34" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.061" y="41.632" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.062" y="40.773" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.062" y="39.915" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.612" y="54.073" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.613" y="53.214" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.613" y="52.355" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.614" y="51.496" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.614" y="50.637" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.615" y="49.778" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.615" y="48.92" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.615" y="48.061" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.086" y="53.647" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.086" y="52.789" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.087" y="51.93" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.087" y="51.071" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.087" y="50.213" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.088" y="49.354" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.088" y="48.495" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.089" y="47.636" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.609" y="60.947" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.61" y="60.088" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.61" y="59.23" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.611" y="58.371" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.611" y="57.512" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.611" y="56.653" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.612" y="55.794" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.612" y="54.935" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.082" y="60.521" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.083" y="59.663" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.083" y="58.804" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.084" y="57.946" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.084" y="57.087" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.084" y="56.228" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.085" y="55.369" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.085" y="54.511" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.606" y="67.812" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.606" y="66.953" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.607" y="66.095" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.607" y="65.236" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.607" y="64.377" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.608" y="63.518" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.608" y="62.659" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.609" y="61.8" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.079" y="67.387" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.08" y="66.528" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.08" y="65.669" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.08" y="64.811" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.081" y="63.952" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.081" y="63.093" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.082" y="62.234" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.082" y="61.375" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.603" y="74.679" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.603" y="73.821" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.604" y="72.962" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.604" y="72.103" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.605" y="71.245" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.605" y="70.386" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.606" y="69.527" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.606" y="68.668" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.076" y="74.255" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.076" y="73.395" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.077" y="72.537" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.077" y="71.678" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.078" y="70.819" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.078" y="69.961" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.078" y="69.102" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.079" y="68.243" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.6" y="81.556" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.6" y="80.697" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.601" y="79.838" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.601" y="78.98" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.601" y="78.121" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.601" y="77.262" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.602" y="76.403" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.602" y="75.544" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.073" y="81.131" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.073" y="80.272" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.073" y="79.413" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.074" y="78.554" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.074" y="77.696" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.075" y="76.837" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.075" y="75.978" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.076" y="75.119" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.596" y="88.43" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.597" y="87.571" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.597" y="86.712" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.598" y="85.853" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.598" y="84.995" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.598" y="84.136" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.599" y="83.277" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.599" y="82.419" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.069" y="88.005" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.07" y="87.146" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.07" y="86.288" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.071" y="85.428" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.071" y="84.569" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.071" y="83.711" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.071" y="82.852" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.072" y="81.993" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.593" y="95.31" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.593" y="94.451" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.594" y="93.592" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.594" y="92.733" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.595" y="91.874" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.595" y="91.015" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.595" y="90.157" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.596" y="89.298" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.066" y="94.885" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.066" y="94.026" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.067" y="93.167" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.067" y="92.308" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.068" y="91.45" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.068" y="90.591" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.069" y="89.731" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.069" y="88.873" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.59" y="102.177" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.59" y="101.318" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.591" y="100.46" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.591" y="99.601" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.591" y="98.742" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.592" y="97.883" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.592" y="97.025" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.593" y="96.166" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.063" y="101.753" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.064" y="100.893" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.064" y="100.035" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.064" y="99.176" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.065" y="98.317" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.065" y="97.458" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.065" y="96.6" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.066" y="95.741" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.587" y="109.053" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.587" y="108.195" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.587" y="107.336" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.588" y="106.477" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.588" y="105.618" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.589" y="104.76" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.589" y="103.901" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.589" y="103.042" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.06" y="108.629" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.06" y="107.769" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.061" y="106.911" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.061" y="106.052" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.061" y="105.193" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.062" y="104.335" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.062" y="103.476" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.062" y="102.617" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.583" y="115.928" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.584" y="115.069" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.584" y="114.21" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.585" y="113.351" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.585" y="112.493" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.585" y="111.634" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.586" y="110.775" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.586" y="109.916" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.056" y="115.503" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.057" y="114.644" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.057" y="113.785" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.057" y="112.926" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.058" y="112.067" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.059" y="111.209" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.059" y="110.35" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.059" y="109.491" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.58" y="122.793" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.58" y="121.934" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.581" y="121.075" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.581" y="120.217" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.582" y="119.358" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.582" y="118.499" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.583" y="117.64" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.583" y="116.782" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.053" y="122.368" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.054" y="121.51" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.054" y="120.65" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.054" y="119.791" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.055" y="118.933" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.055" y="118.074" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.056" y="117.215" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.056" y="116.356" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.577" y="129.66" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.577" y="128.802" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.578" y="127.943" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.578" y="127.084" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.579" y="126.226" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.579" y="125.367" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.579" y="124.508" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.58" y="123.649" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.05" y="129.235" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.05" y="128.376" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.051" y="127.518" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.051" y="126.659" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.051" y="125.801" fill="#010101" width="1.287" height="0.37" />
        <rect x="251.052" y="124.942" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.052" y="124.083" fill="#010101" width="1.287" height="0.371" />
        <rect x="251.053" y="123.224" fill="#010101" width="1.287" height="0.371" />
        <path
          fill="#010101"
          d="M252.707,34.047c-0.005-0.148-0.131-0.271-0.278-0.271h-0.005v0.285h0.047l0.104,1.282h-1.147l0.106-1.282
		h0.047v-0.285h-0.022c-0.15,0-0.275,0.123-0.279,0.271l-0.165,5.359c-0.004,0.148,0.113,0.271,0.263,0.271h1.237
		c0.15,0,0.267-0.123,0.263-0.271L252.707,34.047z M251.479,36.266c0-0.101,0.082-0.18,0.181-0.18h0.676
		c0.099,0,0.18,0.08,0.18,0.18v0.675c0,0.101-0.082,0.181-0.181,0.181h-0.676c-0.099,0-0.18-0.08-0.18-0.181V36.266z
		 M251.998,39.368c-0.33,0-0.597-0.268-0.596-0.597c0-0.329,0.267-0.597,0.597-0.597c0.33,0,0.597,0.268,0.597,0.597
		C252.595,39.101,252.328,39.368,251.998,39.368"
        />
        <rect x="251.687" y="32.971" fill="#010101" width="0.632" height="1.557" />
        <path
          fill="#010101"
          d="M253.371,33.358c0.001-0.717-0.581-1.299-1.297-1.299h-0.14c-0.718,0-1.299,0.582-1.3,1.299
		c0,0.133,0.02,0.262,0.058,0.384c0,0.001,0.001,0.001,0.001,0.002c0.001,0,0.001,0.001,0.001,0.001
		c0.128,0.339,0.127,0.833,0.127,1.306h0.003c0.016,0.259,0.14,0.49,0.327,0.648l0.056-1.755c0.006-0.154,0.144-0.281,0.308-0.281
		h0.068l0.001-0.801h0.842l-0.001,0.801h0.049c0.164,0,0.303,0.127,0.308,0.281l0.061,1.765c0.193-0.158,0.322-0.393,0.339-0.659
		h0.002v-0.038c0-0.007,0.001-0.013,0.001-0.021s-0.001-0.013-0.001-0.02c0.001-0.438,0.007-0.884,0.12-1.203
		C253.347,33.639,253.371,33.502,253.371,33.358"
        />
        <rect x="251.132" y="238.502" fill="#010101" width="1.645" height="0.727" />
        <path
          fill="#010101"
          d="M252.201,241.523h-0.497c-0.528,0-0.956-0.429-0.956-0.957l0.001-1.212h2.408l-0.001,1.212
		C253.157,241.094,252.729,241.523,252.201,241.523"
        />
        <path
          fill="#010101"
          d="M262.673,71.352v13.456l0.679,0.717v37.644l5.716,5.722l0.056,0.056h30.538l5.717-5.721l0.056-0.057V85.48
		l0.583-0.616l0.05-0.057V71.352H262.673z M305.07,123.023l-5.559,5.559h-30.235l-5.559-5.559V85.917l4.338,4.612l0.057,0.057
		h32.527l4.433-4.714V123.023z M305.703,84.667l-5.228,5.554h-32.208l-5.229-5.554V71.722h42.666V84.667z"
        />
        <path
          fill="#010101"
          d="M243.204,199.085c-1.608-4.096-4.058-8.501-7.28-13.108c-3.133-4.473-5.885-7.51-5.907-7.538l-0.14-0.151
		l-37.185,43.013l-0.039,0.045v0.067c-0.017,0.342-1.351,34.024-1.581,36.552c-0.246,2.651,5.066,5.817,5.297,5.951l0.039,0.029
		h40.469l6.809-6.502l0.056-0.055l0.97-48.04C244.717,209.296,245.154,204.56,243.204,199.085 M193.012,221.491l36.87-42.654
		c0.589,0.661,2.976,3.407,5.655,7.23l-43.063,48.746C192.754,227.997,192.984,222.169,193.012,221.491 M244.348,209.324
		l-0.97,47.906l-6.647,6.35h-40.222c-0.499-0.308-5.285-3.279-5.077-5.582c0.135-1.44,0.622-12.895,1.02-22.608l43.304-49.015
		c3.138,4.511,5.531,8.832,7.106,12.834C244.784,204.605,244.353,209.263,244.348,209.324"
        />
        <path
          fill="#010101"
          d="M313.14,257.964c-0.23-2.527-1.564-36.209-1.575-36.551l-0.006-0.067l-37.089-42.907l-0.134-0.151
		l-0.14,0.151c-0.022,0.028-2.774,3.066-5.901,7.538c-3.222,4.607-5.677,9.012-7.291,13.114c-1.945,5.469-1.508,10.206-1.502,10.239
		l0.97,47.984l0.005,0.073l6.81,6.507l0.055,0.05h40.464l0.045-0.028C308.074,263.781,313.387,260.615,313.14,257.964
		 M274.331,178.837l36.871,42.654c0.028,0.678,0.258,6.507,0.538,13.321l-43.063-48.746
		C271.36,182.244,273.748,179.498,274.331,178.837 M307.704,263.579h-40.216l-6.652-6.35l-0.97-47.922
		c-0.006-0.045-0.437-4.702,1.48-10.093c1.581-4.007,3.973-8.328,7.117-12.839l43.299,49.015c0.398,9.712,0.885,21.168,1.02,22.608
		C312.989,260.301,308.208,263.271,307.704,263.579"
        />
        <path
          fill="#010101"
          d="M197.523,71.352v13.456l0.634,0.678v37.683l5.716,5.722l0.056,0.056h30.537l5.723-5.721l0.05-0.057V85.525
		l0.628-0.661l0.044-0.057V71.352H197.523z M239.875,123.023l-5.559,5.559h-30.235l-5.56-5.559V85.872l4.383,4.657l0.05,0.057
		h32.527l4.394-4.674V123.023z M240.548,84.667l-5.223,5.554h-32.214l-5.223-5.554V71.722h42.66V84.667z"
        />
        <path
          fill="#010101"
          d="M364.257,230.631c-0.118-1.798-1.899-28.694-3.52-35.167c-1.692-6.764-3.917-22.932-4.478-29.114
		c-0.572-6.248-7.852-47.67-9.544-51.615c-0.69-1.608-3.133-10.497-5.958-20.786c-3.957-14.403-8.877-32.326-10.855-36.938
		c-2.298-5.358-5.419-10.268-7.101-12.907c-0.65-1.026-1.121-1.765-1.261-2.074c-0.062-0.146-0.146-0.258-0.253-0.336l-0.174-0.129
		c-0.801-0.599-2.869-2.146-3.452-2.572c-3.957-2.892-7.897-5.257-12.049-7.235c-4.243-2.028-8.693-3.671-13.227-4.892
		c-3.609-0.97-7.263-1.816-10.872-2.522c-0.303-0.062-0.527-0.107-0.724-0.146c-0.409-0.085-0.695-0.14-1.283-0.242l0.072-0.179
		c0.398-0.981,0.023-1.99-0.308-2.875c-0.051-0.129-0.095-0.258-0.146-0.387l-4.853-11.691c-0.763-1.832-2.293-3.16-4.092-3.558
		c-2.589-0.566-5.363-0.678-8.047-0.785c-0.617-0.028-1.228-0.05-1.833-0.078c-3.407-0.168-6.876-0.235-10.301-0.208
		c-4.769,0.05-9.695,0.095-14.588,0.813c-0.454,0.067-0.908,0.14-1.367,0.213l-0.527,0.084c-1.065,0.168-2.023,0.734-2.712,1.614
		l-7.319,13.954c-0.594,0.757-0.773,1.732-0.51,2.634c-2.639,0.628-6.221,1.569-9.679,2.539c-3.228,0.908-6.479,1.899-9.662,2.947
		l-0.174,0.056c-2.953,0.975-6.002,1.978-8.832,3.391c-6.439,3.222-13.102,8.748-13.102,9.505c-0.029,0.173-0.617,1.093-1.295,2.157
		c-1.676,2.64-4.803,7.549-7.101,12.907c-1.972,4.612-6.899,22.535-10.856,36.938c-2.825,10.289-5.262,19.178-5.957,20.786
		c-1.687,3.945-8.973,45.367-9.538,51.615c-0.566,6.182-2.792,22.351-4.478,29.114c-0.941,3.755-1.933,14.381-2.628,22.995v0.006
		c-0.499,6.232-0.841,11.41-0.891,12.166c-0.073,0.062-0.123,0.152-0.128,0.258c-0.012,0.174,0.078,0.326,0.235,0.375
		c10.451,3.61,17.58,4.579,22.227,4.579c2.376,0,4.096-0.258,5.279-0.538c0.336-0.078,0.571-0.375,0.622-0.751h0.017
		c0.067-0.37,6.938-37.375,8.44-41.567c1.267-3.542,9.752-34.859,10.844-40.878c0.869-4.786,3.688-18.545,6.607-26.766
		c0.034,7.348,0.336,40.01,0.336,40.351l-0.806,39.835c0.016,1.194-0.107,2.382-0.365,3.537c-1.709,7.706-3.873,23.016-4.444,52.221
		c-0.18,8.983-0.426,19.744-0.684,31.131c-0.936,40.945-1.995,87.355-0.907,92.797c0.537,2.695,0.627,17.939,0.734,35.587
		c0.168,28.15,0.381,63.189,2.46,68.815l0.034,0.084l0.085,0.022c0.134,0.045,9.107,2.741,23.028,2.741
		c7.005,0,15.266-0.684,24.277-2.729c0.191,0,0.191,0,0.382-3.441c0.117-2.08,0.274-5.056,0.459-8.62
		c0.375-7.134,0.863-16.644,1.351-26.155c0.97-19.02,1.928-38.048,1.928-38.048c0.022-0.565,2.382-56.642,1.793-79.872
		c0.785-17.698,4.932-34.848,4.977-35.054c0.274-7.207,1.636-25.92,4.601-26.116c2.886,0.19,4.254,17.961,4.579,25.567
		c-0.006,0.061-0.006,0.1-0.006,0.106h0.011c0.006,0.163,0.012,0.325,0.017,0.477c0.045,0.173,4.191,17.317,4.976,35.01
		c-0.594,23.242,1.771,79.318,1.794,79.884c0,0,0.958,19.027,1.927,38.048c0.488,9.511,0.975,19.022,1.351,26.155
		c0.185,3.564,0.342,6.54,0.46,8.62c0.185,3.429,0.179,3.429,0.336,3.435c9.034,2.045,17.306,2.729,24.318,2.729
		c13.932,0,22.899-2.691,23.033-2.735l0.085-0.022l0.033-0.084c2.079-5.627,2.287-40.671,2.455-68.821
		c0.106-17.648,0.202-32.887,0.74-35.582c1.087-5.442,0.027-51.845-0.908-92.79c-0.185-8.031-0.358-15.748-0.51-22.753
		c-0.062-2.931-0.123-5.733-0.173-8.384c-0.567-28.717-3.105-48.55-5.291-57.539c-0.572-2.349-0.801-4.814-0.683-7.32h-0.006
		l-0.174-0.011h0.185l-0.6-31.373v-41.27c1.978,5.654,4.254,15.4,6.607,28.335c1.093,6.019,9.572,37.336,10.839,40.878
		c1.503,4.191,8.373,41.197,8.446,41.567h0.012c0.055,0.376,0.291,0.673,0.627,0.751c1.177,0.28,2.903,0.538,5.279,0.538
		c4.64,0,11.775-0.969,22.227-4.579c0.151-0.05,0.247-0.201,0.235-0.375C364.38,230.783,364.33,230.694,364.257,230.631
		 M223.791,21.07l7.319-13.955c0.616-0.778,1.491-1.294,2.466-1.451l0.527-0.084c0.46-0.073,0.913-0.14,1.368-0.208
		c4.864-0.717,9.779-0.762,14.531-0.806c3.424-0.034,6.882,0.034,10.278,0.202c0.611,0.028,1.222,0.05,1.844,0.078
		c2.668,0.106,5.426,0.212,7.98,0.778c1.681,0.37,3.116,1.62,3.833,3.34l4.853,11.679c0.045,0.124,0.09,0.252,0.14,0.387
		c0.325,0.864,0.656,1.76,0.314,2.607l-0.084,0.213c-2.079,5.105-6.389,15.698-9.045,18.304c-0.588-0.465-1.564-1.401-2.785-2.579
		c-3.66-3.53-9.157-8.837-12.867-9.65c3.811-2.522,9.965-7.538,11.416-10.587c2.052-3.082,5.078-8.138,5.341-9.371
		c0.163-0.751-0.011-1.569-0.46-2.191c-0.331-0.46-0.981-1.042-2.186-1.182l-0.044,0.364c0.851,0.095,1.524,0.454,1.939,1.032
		c0.381,0.532,0.532,1.261,0.398,1.9c-0.23,1.07-2.976,5.755-5.229,9.152c-16.953-1.76-25.83,0.055-27.03,0.331
		c-0.045-0.085-0.095-0.168-0.134-0.241c-2.253-3.385-5.055-8.155-5.285-9.241c-0.14-0.639,0.011-1.367,0.398-1.9
		c0.415-0.577,1.082-0.936,1.933-1.032l-0.039-0.364c-1.211,0.14-1.861,0.717-2.191,1.182c-0.448,0.622-0.616,1.44-0.46,2.191
		c0.263,1.233,3.29,6.282,5.33,9.337c1.457,3.082,7.571,8.071,11.433,10.615c-3.716,0.818-9.219,6.131-12.901,9.678
		c-1.205,1.161-2.169,2.097-2.757,2.556c-3.087-2.959-9.707-16.78-10.463-18.366C223.051,22.902,223.169,21.871,223.791,21.07
		 M166.313,234.952c-3.452,0.824-11.584,1.396-27.276-4.046c3.206-0.645,14.437-2.287,27.327,2.965
		c0.252,0.106,0.325,0.381,0.309,0.588C166.655,234.661,166.554,234.897,166.313,234.952 M166.812,233.776
		c-0.085-0.101-0.185-0.191-0.309-0.241c-12.75-5.195-23.886-3.694-27.349-3.021c0.073-1.104,0.398-5.941,0.863-11.747
		c1.222-0.213,6.305-1.043,10.508-0.818c0.106,0,10.839,0.263,18.377,4.741C167.916,227.863,167.12,232.105,166.812,233.776
		 M185.962,152.043c-1.093,6.013-9.561,37.285-10.828,40.822c-0.958,2.678-4.001,18.135-6.159,29.451
		c-7.616-4.467-18.337-4.731-18.438-4.731c-4.13-0.224-9.113,0.572-10.491,0.808c0.695-8.58,1.681-19.117,2.612-22.838
		c1.693-6.782,3.923-22.978,4.483-29.17c0.572-6.244,7.835-47.575,9.516-51.504c0.701-1.636,3.144-10.536,5.974-20.836
		c3.957-14.392,8.872-32.304,10.839-36.888c2.287-5.335,5.403-10.228,7.073-12.856c0.577-0.902,0.924-1.458,1.126-1.81
		c3.95,14.168,5.8,28.979,7.593,43.31c0.594,4.757,1.205,9.673,1.889,14.515c1.109,7.858,1.771,16.819,1.776,23.975
		C189.879,132.389,186.864,147.066,185.962,152.043 M251.98,272.086c-2.981,0.717-4.198,15.765-4.606,22.922
		c-0.309-6.558-0.981-21.436-0.757-23.511c0.157-1.468,1.318-2.443,1.995-2.891c1.132-0.757,2.506-1.11,3.368-0.885V272.086z
		 M251.98,267.346c-0.97-0.208-2.376,0.162-3.57,0.958c-1.261,0.835-2.029,1.956-2.157,3.156
		c-0.286,2.684,0.857,25.685,0.907,26.665l0.062-0.006c-0.006,0.152-0.011,0.28-0.017,0.375c-0.039,0.168-4.192,17.351-4.982,35.105
		c0.588,23.224-1.771,79.295-1.793,79.856c-0.039,0.74-3.66,72.599-3.923,75.95c-25.909,5.84-45.479,0.425-46.947,0
		c-2.024-5.834-2.237-40.626-2.405-68.608c-0.106-17.665-0.196-32.92-0.74-35.655c-1.082-5.397,0.022-53.813,0.913-92.712
		c0.258-11.394,0.505-22.154,0.684-31.138c0.572-29.17,2.729-44.459,4.439-52.147c0.257-1.183,0.386-2.399,0.369-3.615l0.813-39.83
		c-0.006-0.369-0.341-36.944-0.341-41.377c0-7.179-0.667-16.173-1.783-24.064c-0.678-4.837-1.294-9.752-1.889-14.504
		c-1.81-14.493-3.682-29.479-7.722-43.803c0.268-0.695,6.35-5.907,12.896-9.18c2.807-1.407,5.845-2.404,8.787-3.374l0.168-0.056
		c3.178-1.049,6.423-2.034,9.651-2.942c3.469-0.976,7.067-1.922,9.707-2.544c0.011,0.027,0.022,0.062,0.039,0.09
		c0.762,1.614,7.561,15.81,10.654,18.584l0.112,0.101l0.118-0.09c0.588-0.437,1.614-1.429,2.92-2.678
		c3.48-3.363,9.275-8.945,12.884-9.606c-0.017,0.135-0.067,0.359-0.179,0.723c-0.073,0.235-0.128,0.42-0.128,0.55
		c-0.006,0.644,0.005,1.289,0.022,1.933c0.034,1.277,0.101,2.578,0.208,3.855l0.039,0.404c0.045,0.504,0.09,1.031,0.095,1.541
		c0.017,1.098,0.006,179.393,0,199.721v0.616c-0.011,0.314-0.033,0.976,0.235,1.356c0.017,0.017,0.415,0.426,0.818,0.578
		c0.017,0.005,0.432,0.135,0.729,0.112c0.078-0.006,0.196-0.006,0.308,0V267.346z M251.644,241.28
		c-0.185,0.012-0.493-0.062-0.583-0.095c-0.308-0.113-0.65-0.466-0.656-0.466c-0.179-0.257-0.163-0.879-0.151-1.109v-0.628
		c0.006-20.327,0.017-198.628,0-199.726c-0.006-0.527-0.056-1.054-0.101-1.57l-0.034-0.404c-0.106-1.266-0.173-2.561-0.207-3.833
		c-0.016-0.639-0.028-1.283-0.022-1.922c0-0.073,0.057-0.27,0.112-0.443c0.123-0.398,0.263-0.869,0.151-1.155
		c-0.011-0.045-0.039-0.083-0.073-0.118c-0.017-0.017-0.039-0.027-0.056-0.045c-3.581-2.325-9.337-6.943-11.236-10.065
		c1.501-0.33,10.255-2.001,26.648-0.313c-1.642,3.076-7.672,7.946-11.343,10.34c-0.028,0.016-0.039,0.039-0.056,0.061
		c-0.006,0.006-0.011,0.017-0.017,0.022c-0.011,0.017-0.028,0.034-0.039,0.057c-0.156,0.263-0.084,0.611-0.016,0.902
		c0.027,0.146,0.061,0.286,0.061,0.398c0.006,0.247,0.011,0.488,0.022,0.729c0.012,0.354,0.022,0.707,0.022,1.054
		c0.006,1.277-0.05,2.567-0.168,3.828c-0.135,1.356-0.196,2.561-0.196,3.688v196.605l0.006,2.539
		c0.006,0.235,0.028,0.857-0.134,1.087c-0.342,0.331-0.835,0.651-1.026,0.623C252.524,241.319,251.93,241.257,251.644,241.28
		 M252.345,272.086v-4.382c0.869-0.191,2.202,0.163,3.312,0.902c0.678,0.448,1.833,1.423,1.99,2.891
		c0.219,2.006-0.404,16.051-0.729,22.882C256.475,286.988,255.242,272.781,252.345,272.086 M309.75,122.738v42.312l0.594,31.372
		h0.006c-0.123,2.539,0.112,5.033,0.689,7.409c2.18,8.972,4.714,28.778,5.279,57.46c0.05,2.651,0.112,5.454,0.174,8.384
		c0.151,7.005,0.325,14.729,0.51,22.76c0.891,38.894,1.995,87.309,0.914,92.706c-0.544,2.735-0.639,17.984-0.745,35.648
		c-0.168,27.988-0.375,62.78-2.404,68.614c-1.463,0.425-21.011,5.834-46.948,0.005c-0.258-3.284-3.884-75.215-3.917-75.955
		c-0.028-0.56-2.387-56.631-1.793-79.872c-0.79-17.738-4.943-34.921-4.982-35.055c0-0.123-0.011-0.292-0.017-0.505
		c0.09-1.86,1.183-23.935,0.902-26.564c-0.128-1.2-0.891-2.321-2.152-3.156c-1.171-0.778-2.544-1.149-3.514-0.969v-25.668
		c0.09,0.011,0.151,0.016,0.151,0.016c0.028,0.006,0.056,0.006,0.09,0.006c0.46,0,1.115-0.605,1.272-0.757
		c0.247-0.358,0.23-1.02,0.219-1.334l-0.011-127.133l0.006-71.998c0-1.11,0.062-2.31,0.191-3.654
		c0.124-1.273,0.179-2.572,0.179-3.861c-0.006-0.354-0.017-0.712-0.028-1.065c-0.011-0.241-0.017-0.483-0.022-0.723
		c-0.005-0.152-0.039-0.308-0.073-0.466c-0.039-0.179-0.067-0.325-0.067-0.443c3.604,0.684,9.152,6.036,12.828,9.583
		c1.273,1.222,2.27,2.191,2.875,2.651c0.112,0.084,0.264,0.078,0.364-0.023c2.651-2.522,6.905-12.89,9.052-18.164
		c0.638,0.107,0.913,0.163,1.351,0.253c0.196,0.039,0.42,0.084,0.728,0.145c3.598,0.701,7.246,1.547,10.844,2.517
		c4.511,1.211,8.944,2.852,13.17,4.864c4.125,1.973,8.048,4.327,11.982,7.202c0.588,0.426,2.651,1.972,3.452,2.572l0.174,0.128
		c0.016,0.012,0.033,0.034,0.05,0.051c-4.254,15.081-6.215,30.011-8.295,45.815c-0.516,3.939-1.047,8.009-1.62,12.037
		C310.238,106.749,309.75,114.437,309.75,122.738 M327.902,192.865c-1.261-3.537-9.729-34.809-10.822-40.822
		c-2.493-13.702-4.904-23.841-6.966-29.333c0-8.272,0.488-15.934,1.457-22.771c0.566-4.029,1.104-8.104,1.62-12.037
		c2.057-15.67,4.008-30.476,8.182-45.412c0.219,0.392,0.605,0.998,1.121,1.81c1.676,2.628,4.792,7.521,7.079,12.856
		c1.962,4.584,6.882,22.496,10.833,36.888c2.83,10.301,5.273,19.2,5.98,20.836c1.681,3.929,8.944,45.26,9.51,51.504
		c0.566,6.193,2.791,22.389,4.489,29.17c0.93,3.726,1.917,14.274,2.606,22.86c-1.183-0.207-6.338-1.054-10.598-0.836
		c-0.112,0.006-10.732,0.27-18.337,4.674C331.892,210.949,328.866,195.543,327.902,192.865 M334.128,222.628
		c7.527-4.416,18.164-4.679,18.276-4.685c4.355-0.225,9.651,0.672,10.62,0.846c0.46,5.794,0.785,10.62,0.857,11.724
		c-3.458-0.678-14.594-2.174-27.343,3.021c-0.123,0.05-0.224,0.14-0.308,0.241C335.916,232.1,335.12,227.829,334.128,222.628
		 M364.033,230.923c-15.72,5.425-23.852,4.853-27.304,4.029c-0.246-0.055-0.348-0.291-0.364-0.493
		c-0.016-0.208,0.056-0.483,0.309-0.588c7.235-2.948,13.943-3.722,19.004-3.722c3.995,0,6.961,0.482,8.355,0.762V230.923z"
        />
      </g>
    </svg>
  );
}
